import type { TypePolicies } from '../../../utils';
import { cursorPaginationFieldPolicy } from '../../../utils/policies';
import { FINDER_ITEM_KEY_ARGS } from './constants';

export const typePolicies: TypePolicies = {
  FolderAsset: {
    fields: {
      groupInformation: {
        keyArgs: FINDER_ITEM_KEY_ARGS,
      },
      matchingChildren: {
        ...cursorPaginationFieldPolicy(),
        keyArgs: FINDER_ITEM_KEY_ARGS,
      },
    },
  },
};
